import React from 'react';

import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import { BlogPostsMacroHandler } from '@confluence/blog-posts-macro/entry-points/BlogPostsMacroRenderer.ts';
import type { BlogPostsMacroParams } from '@confluence/blog-posts-macro/entry-points/blogPostMacroTypes.ts';

import { NestedAdfRendererWrapperProvider } from '../NestedAdfRendererWrapper.tsx';

type BlogPostsExtensionHandlerProps = ExtensionHandlerProps & {
	Renderer: React.FC<any>;
	appearance?: string;
	macroParams?: BlogPostsMacroParams;
};

export const BlogPostsExtensionHandler = ({
	Renderer,
	appearance,
	macroParams,
	...macroDefaultProps
}: BlogPostsExtensionHandlerProps): React.JSX.Element => (
	<NestedAdfRendererWrapperProvider Renderer={Renderer} appearance={appearance}>
		{(RendererWrapper) => (
			<BlogPostsMacroHandler
				macroDefaultProps={macroDefaultProps}
				macroParams={macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfRendererWrapperProvider>
);
